import(/* webpackMode: "eager", webpackExports: ["MemberProfilePage"] */ "/app/src/app/(browse)/member/[id]/MemberProfilePage.tsx");
